export interface HomeSlider {
    id?: string;
    desktop?: string;
    mobile?: string;
    url?: string;
    index?: number;
  }

  export function createHomeSlider() : HomeSlider{
    return {
      id: null,
      desktop: null,
      mobile: null,
      url: null,
      index: 0,
    }
  }